export * from './confirmation-popover.module';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/confirmation-popover/index.ts